// useWantlistHandlers.js - Extracted wantlist modal handlers from App.js
import { useModal } from '../contexts/ModalContext';
import { useNotification } from '../contexts/NotificationContext';

export const useWantlistHandlers = ({
  hasWantedReleases,
  userWantlist,
  addReleaseToWantlist,
  loadUserWantlist,
}) => {
  const modal = useModal();
  const { showError } = useNotification();

  // Wantlist modal handlers
  const handleWantlistModalClick = movie => {
    // Always open the unified wantlist modal that shows all releases
    modal.openWantlistModal(movie, userWantlist);
  };

  const handleWantlistReleaseSelected = async (
    releaseDisplayId,
    notes = '',
    shouldCloseModal = false
  ) => {
    try {
      const result = await addReleaseToWantlist(releaseDisplayId, notes);

      if (result.success) {
        // Only close modal if explicitly requested (for old add mode)
        if (shouldCloseModal) {
          modal.closeModal('wantlistRelease');
        }
        // Reload wantlist to get updated data
        loadUserWantlist();
      } else {
        showError('Error adding to wantlist: ' + result.error);
      }
    } catch (error) {
      console.error('Error adding to wantlist:', error);
      showError('Error adding to wantlist');
    }
  };

  const handleCloseWantlistModal = () => {
    modal.closeModal('wantlistRelease');
  };

  const handleCloseWantedReleasesModal = () => {
    modal.closeModal('wantedReleases');
  };

  return {
    handleWantlistModalClick,
    handleWantlistReleaseSelected,
    handleCloseWantlistModal,
    handleCloseWantedReleasesModal,
  };
};
